import { useExteriorSectionData } from '../useExteriorSection';
import { useLevel1SectionData } from '../useLevel1Section';

const generalSections = [
  'driver_doors',
  'passenger_doors',
  'driver_side_rocker',
  'passenger_side_rocker',
  'under_body',
  'driver_quarter',
  'passenger_rear_quarter',
  'trunk_driver_side',
  'trunk_passenger_side',
  'spare_tire'
];

export const useFitFinishFrameSections = () => {
  const { subSections } = useExteriorSectionData('fit_finish_frame');
  const { subSections: underHoodSubSections } = useLevel1SectionData('under_hood');

  return [
    underHoodSubSections.frame_fit_finish_under_hood,
    underHoodSubSections.under_hood_3_point_body_lines_paint_check,
    ...generalSections.map(key => subSections[key])
  ].filter(Boolean);
};
